module.exports = __webpack_public_path__ + "static/img/yh-rectify.d2144b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/yh-rectify.svg
// module id = GGMR
// module chunks = 6